import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import "../../config/i18n";
import ls from "local-storage";
import Confetti from "react-confetti";
import { options } from "../../config/options";
import { NavLink } from "react-router-dom";
import Swiper from "react-id-swiper";
import axios from "axios";
import Countdown from "../findExplore/Countdown";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
// import { BrowserRouter as Route } from "react-router-dom";
import Slider from "react-slick";
import Loader from "react-loader-spinner";
import { CAPTURE_EVENT } from "../../Services/PosthogService";
import { userSend } from "../../Services/ActivityServices";

class LikeRequestNew extends Component {
  constructor(props) {
    super(props);
    this.reportToggle = this.reportToggle.bind(this);
    this.SetReport = this.SetReport.bind(this);
    this.Message = this.Message.bind(this);
    this.getSessionDetails = this.getSessionDetails.bind(this);

    this.state = {
      userDetails: {},
      dropdownOpen: false,
      profile_userid: "",
      user_details: "",

      like: "like",
      superlike: "superlike",
      modal11: false,
      modal12: false,
      modal13: false,
      followername: "",
      userprofile: "",
      followerprofile: "",
      premiumstatus: "",
      followerpremstatus: "",
      gif: "no",
      superlikeItems: [],
      superlikeCount: 0,
      itemss: [],
      superlikePlanStatus: 0,
      selected_superlikepremium: "",
      currency: "",
      payment: "",
      license_key: "",
      superlikepremium_price: "",
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue"),
      start_date: "",
      end_date: "",
      total_hours: "",
      like_status: "",
      timer_status: 0,

      image: [],
      api_url: localStorage.getItem("api_url"),
      interest: [],
      report: "",
      value_id: "",
      suc_msg: "",
      errors: "",
      loader: "",
      profilespace: "none",
      type: "false",
      friend_box: "none",
    };
  }

  async getSessionDetails() {
    try {
      let url = this.state.api_url + "webprofile";
      let data = new FormData();
      data.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      data.append("language", this.state.langKey);
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("session_token")
      );
      let options = { headers: { "Content-Type": "multipart/form-data" } };
      let user = await axios.post(url, data, options);
      this.setState({
        userDetails: user.data.result,
      });
    } catch (error) {
      console.log(error);
    }
  }

  addDefaultSrc(ev) {
    ev.target.src = require("../../assets/img/howzu-logo-default.png");
  }

  componentDidMount() {
    this.getSessionDetails();
    this.setState({
      loader: "loder-icon",
    });
    setTimeout(() => {
      this.setState({
        profilespace: "ProfileSpace",
        loader: "none",
      });
    }, 300);
    const {
      match: { params },
    } = this.props;
    //const profile_id = params.userId;
    var profile = new FormData();
    profile.append(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    profile.append("friend_id", params.userId);
    profile.append("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webprofilenew",
      data: profile,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then((res) => {
        const user_details = res.data.result;
        // console.log("user_details",user_details)
        if (res.data.status === "true") {
          if (user_details.report === "false") {
            this.setState({ report: "Report User" });
          } else {
            this.setState({ report: "Unreport User" });
          }
          if (
            user_details.send_match !== "3" &&
            user_details.send_match !== "1" &&
            user_details.send_match !== "7" &&
            user_details.send_match !== "0"
          ) {
            this.setState({
              friend_box: "apt20 apk-16  d-flex justify-content-center amb20",
            });
          }
          this.setState({
            user_details: user_details,
            profile_userid: user_details.user_id,
            image: user_details.imagess,
            interest: user_details.interest_other,
          });
        }
      })
      .catch((error) => {
        this.props.history.push("/app/NotFound");
      });
    var visitprofile = new FormData();
    visitprofile.append("visit_user_id", params.userId);
    visitprofile.append("language", this.state.langKey);
    visitprofile.append(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    axios({
      method: "post",
      url: this.state.api_url + "webvisitprofile",
      data: visitprofile,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      if (res.data.status === "true") {
        this.setState({ type: res.data.type });
      }
    });

    var premiumlist = new FormData();
    premiumlist.set("platform", "web");
    premiumlist.set("language", this.state.langKey);
    premiumlist.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "premiumlistweb",
      data: premiumlist,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const data = res.data;
      if (data.result[0]) {
        this.setState({
          itemss: data.result,
          activeItems: data.result[0].id,
          selected_premium: data.result[0].id,
          premium_price: data.result[0].original_price,
          permium_superlikeCount: data.result[0].superlikecount,
          permium_boostCount: data.result[0].boostcount,
          currency: data.currency,
          payment: data.payment,
          license_key: data.license_key,
          start_date: data.start_date,
          end_date: data.end_date,
          timer_status: data.timer_status,
        });
      }
      localStorage.setItem(
        "selected_premium",
        JSON.stringify(this.state.selected_premium)
      );
      localStorage.setItem(
        "premium_price",
        JSON.stringify(this.state.premium_price)
      );
      localStorage.setItem(
        "currency_premium_price",
        JSON.stringify(data.result[0].price)
      );
      localStorage.setItem("currency", JSON.stringify(this.state.currency));
    });
  }
  closeModal(tabId) {
    this.setState({
      [tabId]: false,
    });

    if (tabId == "modal12" || tabId == "modal11" || tabId == "modal13") {
      this.props.history.push("../../LikeRequests");
    }
  }
  showModal(modal) {
    if (modal === "modal6") {
      let premium_view_properties = {
        properties: {
          user_email: this.state.userDetails.email,
          user_age: this.state.userDetails.age,
          user_name: this.state.userDetails.user_name,
          user_id: this.state.userDetails.user_id,
          user_location: this.state.userDetails.location,
        },
      };

      CAPTURE_EVENT("superlike_page_viewed", premium_view_properties);
    }
    if (modal === "modal15") {
      let premium_view_properties = {
        properties: {
          user_email: this.state.userDetails.email,
          user_age: this.state.userDetails.age,
          user_name: this.state.userDetails.user_name,
          user_id: this.state.userDetails.user_id,
          user_location: this.state.userDetails.location,
        },
      };

      CAPTURE_EVENT("premium_page_viewed", premium_view_properties);
    }
    if (modal === "modal3") {
      var profile = new FormData();
      profile.append(
        "user_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      profile.append("language", this.state.langKey);

      axios({
        method: "post",
        url: this.state.api_url + "webgetcheck",
        data: profile,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        // const user_details = res.data.result;

        if (res.data.status === "true") {
          if (res.data.superlike_count === "0") {
            var premiumlist = new FormData();
            premiumlist.append(
              "user_id",
              JSON.parse(localStorage.getItem("session_userid"))
            );
            premiumlist.append("platform", "web");
            premiumlist.append("language", this.state.langKey);

            axios({
              method: "post",
              url: this.state.api_url + "websuperlikelist",
              data: premiumlist,
              config: { headers: { "Content-Type": "multipart/form-data" } },
            }).then((res) => {
              if (res.data.status === "true") {
                const data = res.data;

                let super_like_view_properties = {
                  properties: {
                    user_email: this.state.userDetails.email,
                    user_age: this.state.userDetails.age,
                    user_name: this.state.userDetails.user_name,
                    user_id: this.state.userDetails.user_id,
                    user_location: this.state.userDetails.location,
                  },
                };

                CAPTURE_EVENT(
                  "superlike_page_viewed",
                  super_like_view_properties
                );

                this.setState({
                  superlikeItems: data.result,
                  activeItem: data.result[0].id,
                  selected_superlikepremium: data.result[0].id,
                  superlikepremium_price: data.result[0].original_price,
                  currency: data.currency,
                  payment: data.payment,
                  license_key: data.license_key,
                  superlikePlanStatus: 1,
                  superlikeCount: data.superlike_count,
                });
                localStorage.setItem(
                  "selected_superlikepremium",
                  JSON.stringify(this.state.selected_superlikepremium)
                );
                localStorage.setItem(
                  "superlikepremium_price",
                  JSON.stringify(this.state.superlikepremium_price)
                );
                localStorage.setItem(
                  "currency",
                  JSON.stringify(this.state.currency)
                );

                this.showModal("modal6");
              }
            });
          } else {
            this.setState({
              [modal]: true,
            });
          }
        } else {
          this.setState({
            [modal]: true,
          });
        }
      });
    } else {
      this.setState({
        [modal]: true,
      });
    }
    // console.log(this.state);
  }
  showModal2(modal) {
    this.setState({
      [modal]: true,
      activeTab: "2",
    });
  }
  handleFriendRequest(user_id, reqType) {
    let errors = {};

    var match = new FormData();
    match.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    match.append("follow_id", user_id);
    match.append("type", reqType);
    match.append("language", this.state.langKey);

    let properties = {
      properties: {
        sender_id: this.state.userDetails.user_id,
        sender_email: this.state.userDetails.email,
        sender_age: this.state.userDetails.age,
        sender_name: this.state.userDetails.user_name,
        sender_location: this.state.userDetails.location,
        receiver_id: this.state.user_details.user_id,
        receiver_name: this.state.user_details.user_name,
        receiver_email: this.state.user_details.email,
        receiver_location: this.state.user_details.location,
      },
    };

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );
    axios({
      method: "post",
      url: this.state.api_url + "webmatch",
      data: match,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const userDetails = res.data.likeresult;
      const matchtotalcount = userDetails.unblock_to_match_count;
      if (res.data.status === "true") {
        if (reqType == "like") {
          CAPTURE_EVENT("like_sent", properties);
        } else {
          CAPTURE_EVENT("superlike_sent", properties);
          userSend(this.state.user_details.user_id,"super_like").then(()=>{
            console.log("Superlike Send")
          }).catch(()=>{})
        }

        if (reqType == "like") {
          var totallike = localStorage.getItem("totallikecount");
          localStorage.setItem("totallikecount", ++totallike);
        }

        reqType === "superlike"
          ? this.closeModal("modal3")
          : this.closeModal("modal1");

        if (
          (reqType === "like" || reqType === "superlike") &&
          res.data.match == 1
        ) {
          let match_properties = {
            properties: {
              acceptor_id: this.state.userDetails.user_id,
              acceptor_email: this.state.userDetails.email,
              acceptor_age: this.state.userDetails.age,
              acceptor_location: this.state.userDetails.location,
              acceptor_name: this.state.userDetails.name,
              requestor_id: this.state.user_details.user_id,
              requestor_email: this.state.user_details.email,
              requestor_name: this.state.user_details.user_name,
            },
          };

          CAPTURE_EVENT("match_created", match_properties);
          this.showModal("modal11");
          this.setState({
            followername: userDetails.follow_firstname,
            followerprofile: userDetails.follow_profileimage,
            followerpremstatus: userDetails.follow_premiumstatus,
            userprofile: userDetails.profileimage,
            gif: "yes",
          });
        } else if (
          reqType === "like" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 1 &&
          userDetails.premiumstatus == 0
        ) {
          var afterlike = localStorage.getItem("totallikecount");

          if (afterlike > matchtotalcount) {
            this.showModal("modal12");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              premiumstatus: userDetails.premiumstatus,
              //gif:'yes'
            });

            localStorage.setItem("totallikecount", 0);
          } else {
            this.props.history.push("../../LikeRequests");
          }
        } else if (
          reqType === "like" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 0 &&
          userDetails.premiumstatus == 1
        ) {
          var afterlike = localStorage.getItem("totallikecount");

          if (afterlike > matchtotalcount) {
            this.showModal("modal13");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              premiumstatus: userDetails.premiumstatus,
              //gif:'yes'
            });
            // setTimeout(() => this.closeModal('modal13'), 2000)

            localStorage.setItem("totallikecount", 0);
          } else {
            this.props.history.push("../../LikeRequests");
          }
        } else if (
          reqType === "superlike" &&
          res.data.match == 0 &&
          ((userDetails.follow_premiumstatus == 1 &&
            userDetails.premiumstatus == 0) ||
            (userDetails.follow_premiumstatus == 0 &&
              userDetails.premiumstatus == 1))
        ) {
          this.showModal("modal13");
          this.setState({
            followername: userDetails.follow_firstname,
            followerprofile: userDetails.follow_profileimage,
            followerpremstatus: userDetails.follow_premiumstatus,
            userprofile: userDetails.profileimage,
            premiumstatus: userDetails.premiumstatus,
            //gif:'yes'
          });
          //   setTimeout(() => this.closeModal('modal13'), 2000)
        } else if (
          reqType === "like" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 0 &&
          userDetails.premiumstatus == 0
        ) {
          var afterlike = localStorage.getItem("totallikecount");

          if (afterlike > matchtotalcount) {
            this.showModal("modal12");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              premiumstatus: userDetails.premiumstatus,
              //gif:'yes'
            });

            localStorage.setItem("totallikecount", 0);
          } else {
            this.props.history.push("../../LikeRequests");
          }
        } else if (
          reqType === "superlike" &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 0 &&
          userDetails.premiumstatus == 0
        ) {
          this.showModal("modal13");
          this.setState({
            followername: userDetails.follow_firstname,
            followerprofile: userDetails.follow_profileimage,
            followerpremstatus: userDetails.follow_premiumstatus,
            userprofile: userDetails.profileimage,
            premiumstatus: userDetails.premiumstatus,
            //gif:'yes'
          });

          //  setTimeout(() => this.closeModal('modal13'), 2000)
        } else if (
          (reqType === "like" || reqType === "superlike") &&
          res.data.match == 0 &&
          userDetails.follow_premiumstatus == 1 &&
          userDetails.premiumstatus == 1
        ) {
          var afterlike = localStorage.getItem("totallikecount");

          if (afterlike > matchtotalcount && reqType === "like") {
            this.showModal("modal13");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              //gif:'yes'
            });
            setTimeout(() => this.closeModal("modal13"), 2000);

            localStorage.setItem("totallikecount", 0);
          } else if (reqType === "superlike") {
            this.showModal("modal13");
            this.setState({
              followername: userDetails.follow_firstname,
              followerprofile: userDetails.follow_profileimage,
              followerpremstatus: userDetails.follow_premiumstatus,
              userprofile: userDetails.profileimage,
              //gif:'yes'
            });
            //  setTimeout(() => this.closeModal('modal13'), 2000)
          } else {
            this.props.history.push("../../LikeRequests");
          }
        } else {
          this.props.history.push("../../LikeRequests");
        }
        /* if(res.data.match === "1") { 
                    this.showModal('modal5'); 


                } else {  
                    errors["frndreq"] = res.data.message; 
                    setTimeout(() => {
                        this.setState({
                            errors: errors,
                            suc_msg: 'successMsg floatingAlerts1'  
                            //suc_msg: 'successMsghide', 
                        });
                         this.props.history.push("../../LikeRequests");  
                    }, 2000); 
                } */
      } else {
        reqType === "superlike"
          ? this.closeModal("modal3")
          : this.closeModal("modal1");

        if (reqType === "superlike" && res.data.superlike_count === "0") {
          var premiumlist = new FormData();
          premiumlist.append(
            "user_id",
            JSON.parse(localStorage.getItem("session_userid"))
          );
          premiumlist.append("platform", "web");
          premiumlist.append("language", this.state.langKey);

          axios({
            method: "post",
            url: this.state.api_url + "websuperlikelist",
            data: premiumlist,
            config: { headers: { "Content-Type": "multipart/form-data" } },
          }).then((res) => {
            if (res.data.status === "true") {
              const data = res.data;

              let super_like_view_properties = {
                properties: {
                  user_email: this.state.userDetails.email,
                  user_age: this.state.userDetails.age,
                  user_name: this.state.userDetails.user_name,
                  user_id: this.state.userDetails.user_id,
                  user_location: this.state.userDetails.location,
                },
              };

              CAPTURE_EVENT(
                "superlike_page_viewed",
                super_like_view_properties
              );

              this.setState({
                superlikeItems: data.result,
                activeItem: data.result[0].id,
                selected_superlikepremium: data.result[0].id,
                superlikepremium_price: data.result[0].original_price,
                currency: data.currency,
                payment: data.payment,
                license_key: data.license_key,
                superlikePlanStatus: 1,
                superlikeCount: data.superlike_count,
              });
              localStorage.setItem(
                "selected_superlikepremium",
                JSON.stringify(this.state.selected_superlikepremium)
              );
              localStorage.setItem(
                "superlikepremium_price",
                JSON.stringify(this.state.superlikepremium_price)
              );
              localStorage.setItem(
                "currency",
                JSON.stringify(this.state.currency)
              );

              this.showModal("modal6");
            }
          });
        } else {
          errors["frndreq"] = res.data.message;
          setTimeout(() => {
            this.setState({
              errors: errors,
              suc_msg: "successMsg floatingAlerts1",
              //suc_msg: 'successMsghide',
            });
          }, 2000);
          // window.location.reload();
        }
      }
    });
  }

  handleSuperlikeItemClick(index) {
    this.setState({
      activeItem: index,
      selected_superlikepremium: index,
    });

    var premiumsuperlikelist = new FormData();
    premiumsuperlikelist.set("premiumsuperlikeid", index);
    premiumsuperlikelist.set("language", this.state.langKey);
    premiumsuperlikelist.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );

    axios({
      method: "post",
      url: this.state.api_url + "premiumsuperlikeid",
      data: premiumsuperlikelist,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const data = res.data;
      this.setState({
        superlikepremium_price: data.result.original_price,
      });
      localStorage.setItem("selected_superlikepremium", JSON.stringify(index));
      localStorage.setItem(
        "superlikepremium_price",
        JSON.stringify(data.result.original_price)
      );
    });
  }

  disLike(user_id) {
    let errors = {};
    errors["frndreq"] = "User declined sucessfully";
    this.setState({
      errors: errors,
      suc_msg: "successMsg floatingAlerts1",
    });
    setTimeout(() => {
      this.setState({
        suc_msg: "successMsghide",
      });
    }, 2000);

    var match = new FormData();
    match.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    match.append("follow_id", user_id);
    match.append("language", this.state.langKey);

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );
    axios({
      method: "post",
      url: this.state.api_url + "webunmatch",
      data: match,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      //console.log(res.data.status);
      this.props.history.push("../../LikeRequests");
      // window.location.reload();
    });
  }

  Message() {
    var report = new FormData();
    report.append(
      "sender_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    report.append("receiver_id", this.state.profile_userid);
    report.append("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webcreatchat",
      data: report,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const chatid = res.data.chatid;
      // console.log("chatid",chatid);
      this.props.history.push(
        `/app/Message/MessageNew/${this.state.profile_userid}/${chatid}`
      );
    });
  }

  reportToggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }
  handleItemClick(index) {
    this.setState({
      activeItems: index,
      selected_premium: index,
    });
    var premiumlist = new FormData();
    premiumlist.set("premiumid", index);
    premiumlist.set("language", this.state.langKey);
    premiumlist.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("session_token")
    );

    axios({
      method: "post",
      url: this.state.api_url + "premiumid",
      data: premiumlist,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const data = res.data;
      this.setState({
        premium_price: data.result.original_price,
        permium_superlikeCount: data.result.superlikecount,
        permium_boostCount: data.result.boostcount,
      });
      localStorage.setItem("selected_premium", JSON.stringify(index));
      localStorage.setItem(
        "premium_price",
        JSON.stringify(data.result.original_price)
      );
      localStorage.setItem(
        "currency_premium_price",
        JSON.stringify(data.result.price)
      );
    });
  }
  SetReport(e) {
    var report = new FormData();
    report.append(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    report.append("report_user_id", this.state.profile_userid);
    report.append("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webreport",
      data: report,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      //const user_details = res.data.result;
      // console.log("profile_det",res.data);
      if (this.state.report === "Report User") {
        this.setState({ report: "Unreport User" });
      } else {
        this.setState({ report: "Report User" });
      }
    });
    this.closeModal("modal4");
  }
  render() {
    const { t } = this.props;

    let age,
      loc,
      txt,
      bio,
      job,
      company,
      school,
      borderFlag = 0;
    if (this.state.user_details.show_age === "true") {
      age = "";
    } else {
      age = this.state.user_details.age;
    }
    if (this.state.user_details.show_location === "true") {
      loc = "";
      txt = "";
    } else {
      txt = "Lives In";
      loc = this.state.user_details.location;
    }
    const settings = {
      dots: true,
      arrows: false,
      infinite: false,
      speed: 500,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    /*const params = {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            spaceBetween: 1
        }*/
    if (this.state.user_details.bio) {
      bio = (
        <div className="interestsHolder apt5 apk-16 border-top breakall">
          <div className="apt10 apb10">{this.state.user_details.bio}</div>
        </div>
      );
    } else {
      bio = "";
    }

    if (this.state.user_details.job) {
      borderFlag = 1;
      job = (
        <div className="interestsHolder apb5 apk-16 breakall">
          {this.state.user_details.job}
        </div>
      );
    }

    if (this.state.user_details.company) {
      borderFlag = 1;
      company = (
        <div className="interestsHolder apb5 apk-16 breakall">
          {this.state.user_details.company}
        </div>
      );
    }

    if (this.state.user_details.school) {
      borderFlag = 1;
      school = (
        <div className="interestsHolder apb5 apk-16 breakall">
          {this.state.user_details.school}
        </div>
      );
    }

    var style = {
      zIndex: 10,
      backgroundColor: "white",
      height: "80vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      //width:"100%",
      overflowY: "hidden",
    };

    const params = {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      spaceBetween: 1,
      rebuildOnUpdate: true,
    };

    const params2 = {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 3,
      slidesPerColumn: 1,
      breakpoints: {
        360: {
          slidesPerView: 3,
        },
        359: {
          slidesPerView: 2,
        },
      },
    };

    return (
      <div className="setting-page">
        <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg amb10 ">
          <div class="heading-left-top d-flex">
            <div className="align-self-center ">
              <NavLink to="/app/LikeRequests">
                <div className="iconHolder align-self-center ">
                  <div className="backGlow">
                    <div className="backIco"></div>
                  </div>
                </div>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="settingsPageWidth profileSectionView">
          <div className={this.state.loader}>
            <div style={style} id="loader">
              <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
            </div>
          </div>

          {this.state.gif == "yes" ? <Confetti recycle={false} /> : ""}

          <div className={this.state.profilespace}>
            <div className="peopleINSpaceHolder">
              <div className="peopleINViewHolder">
                <div className="peopleINPic relPos">
                  <Slider {...settings}>
                    {this.state.image.map((image_tmp) => (
                      <div>
                        {" "}
                        <img
                          onError={this.addDefaultSrc}
                          src={image_tmp}
                          id="current_image"
                          alt=""
                          value={image_tmp}
                          onChange={() => {
                            this.handleswipe(image_tmp);
                          }}
                          className=""
                        />
                      </div>
                    ))}
                  </Slider>
                  <div
                    class={
                      this.state.user_details.premium_member === "true"
                        ? "preIcon2"
                        : "none"
                    }
                  ></div>
                </div>
                <div className="apd10 apt25 ">
                  <div
                    className={
                      borderFlag === 1
                        ? "media relPos apb15 border-bottom amb5"
                        : "media relPos apb15"
                    }
                  >
                    <div className="media-body pFHidden align-self-center">
                      <div class="d-flex align-items-center">
                        <div className="text-truncate bold-font BtoRcolor">
                          {this.state.user_details.user_name}, {age}
                        </div>
                        {this.state.user_details.face_verified &&
                          this.state.user_details.face_verified === "true" && (
                            <div class="verificationIcon"></div>
                          )}
                      </div>
                      <div className="text-truncate secondaryText esmh-14 regular-font">
                        <Trans i18nKey={txt}>{txt}</Trans> {loc}
                      </div>
                    </div>

                    <div className="iconHolder align-self-end ml-1">
                      <div className="backGlow">
                        <Dropdown
                          isOpen={this.state.dropdownOpen}
                          toggle={this.reportToggle}
                        >
                          <DropdownToggle className="RSoverride">
                            <div className="threeDotMenuIcon"></div>
                          </DropdownToggle>
                          <DropdownMenu className="dropDownRSoverride reportDropPos">
                            <div className="text-center">
                              <button
                                className="textBtn"
                                onClick={this.showModal.bind(this, "modal4")}
                                value={this.state.user_details.user_id}
                              >
                                <Trans i18nKey={this.state.report}>
                                  {this.state.report}
                                </Trans>
                              </button>
                            </div>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>

                    {/* <div className="circularIcoHolder circularIcoHolderMadjust">
                                            <div className="circularMessageIco"></div>
                                        </div> */}
                  </div>

                  {job}
                  {company}
                  {school}

                  {bio}
                  <div className="interestsHolder apt5 apk-16 border-top">
                    <div className="bold-font">
                      {this.state.user_details.ex_web}{" "}
                      <Trans i18nKey="interest">interest</Trans>
                    </div>

                    <div className="d-flex flex-wrap apt10 apb10">
                      {this.state.interest &&
                        this.state.interest.map((interest_tmp) => (
                          <div className="btn-border">
                            <Trans i18nKey={interest_tmp}>{interest_tmp}</Trans>{" "}
                          </div>
                        ))}
                    </div>
                  </div>

                  {/* <div className="apt20 apk-16  d-flex justify-content-center amb20"> */}
                  <div className={this.state.friend_box}>
                    <div className={this.state.suc_msg}>
                      <Trans i18nKey={this.state.errors.frndreq}>
                        {this.state.errors.frndreq}
                      </Trans>
                    </div>
                    <div
                      className="likeButton2"
                      title={t("Like")}
                      onClick={this.showModal.bind(this, "modal1")}
                    ></div>
                    <div
                      className="superlikeButton2 mx-4"
                      title={t("Super like")}
                      onClick={this.showModal.bind(this, "modal3")}
                    ></div>
                    <div
                      className="dislikeButton"
                      title={t("Dislike")}
                      onClick={this.showModal2.bind(this, "modal2")}
                    ></div>
                  </div>
                  {this.state.type !== "false" && (
                    // <div className={this.state.type_box}>
                    // {this.state.type === "like"?
                    // <div className="d-flex bold-font justify-content-center"> <Trans i18nKey="Your like is gone">Your like is gone</Trans></div>
                    // :
                    // <div className="d-flex bold-font justify-content-center"> <Trans i18nKey="Your superlike is gone">Your superlike is gone</Trans></div>
                    // }
                    // </div>

                    <div className={this.state.type_box}>
                      {this.state.type === "like" ? (
                        <div className="d-flex bold-font justify-content-center">
                          <Trans i18nKey="Your like is gone">
                            Your like is gone
                          </Trans>
                        </div>
                      ) : this.state.type === "superlike" ? (
                        <div className="d-flex bold-font justify-content-center">
                          <Trans i18nKey="Your superlike is gone">
                            Your superlike is gone
                          </Trans>
                        </div>
                      ) : this.state.type === "unlike" ? (
                        <div className="d-flex bold-font justify-content-center">
                          <Trans i18nKey="Request rejected by you">
                            Request rejected by you
                          </Trans>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modal1}
          toggle={this.closeModal.bind(this, "modal1")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal1")}>
            <h4 class="modal-title">
              <Trans i18nKey="Do you want like this user ?">
                Do you want like this user ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={() => {
                      this.handleFriendRequest(
                        this.state.user_details.user_id,
                        this.state.like
                      );
                    }}
                  >
                    <Trans i18nKey="Yes">Yes</Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal1")}
                  >
                    <Trans i18nKey="No">No</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal3}
          toggle={this.closeModal.bind(this, "modal3")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal3")}>
            <h4 class="modal-title">
              <Trans i18nKey="Do you want super like this user ?">
                Do you want super like this user ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={() => {
                      this.handleFriendRequest(
                        this.state.user_details.user_id,
                        this.state.superlike
                      );
                    }}
                  >
                    <Trans i18nKey="Yes">Yes</Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal3")}
                  >
                    <Trans i18nKey="No">No</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal2}
          toggle={this.closeModal.bind(this, "modal2")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal2")}>
            <h4 class="modal-title">
              <Trans i18nKey="Do you want to decline ?">
                Do you want to decline ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={() => {
                      this.disLike(this.state.user_details.user_id);
                    }}
                  >
                    <Trans i18nKey="Yes">Yes</Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal2")}
                  >
                    <Trans i18nKey="No">No</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal4}
          toggle={this.closeModal.bind(this, "modal4")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal4")}>
            <h4 class="modal-title">
              <Trans i18nKey="Are you sure ?">Are you sure ?</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.SetReport}
                  >
                    <Trans i18nKey="Yes">Yes</Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal4")}
                  >
                    <Trans i18nKey="No">No</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal5}
          toggle={this.closeModal.bind(this, "modal5")}
          className="premiumPopup matchPopup vertically-center apd5"
        >
          <ModalHeader
            toggle={this.closeModal.bind(this, "modal5")}
          ></ModalHeader>
          <ModalBody>
            <div class="modal-images media">
              <div class="matchmedia">
                <img
                  src={this.state.user_details.loguser_image}
                  alt=""
                  className=""
                />
              </div>
              <div class="matchlike"></div>
              <div class="matchmedia">
                <img
                  src={this.state.user_details.user_image}
                  alt=""
                  className=""
                />
              </div>
            </div>

            <div class="justify-content-end text-center matchContent">
              <Trans i18nKey="It's a Match!">It's a Match!</Trans>
            </div>
            <div class="justify-content-end text-center matchContentSub">
              <Trans i18nKey="Bel Baraka">Bel Baraka</Trans>
            </div>
            <div class="justify-content-end text-center">
              <button
                class="bg-white pink-color matchButton"
                onClick={this.Message}
              >
                <Trans i18nKey="Send message">Send message</Trans>
              </button>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal6}
          toggle={this.closeModal.bind(this, "modal6")}
          className="premiumPopup superlikePopup vertically-center apd5"
        >
          <ModalHeader
            toggle={this.closeModal.bind(this, "modal6")}
          ></ModalHeader>
          <ModalBody>
            <div className="boostPopupIcon"></div>
            <div className="premiumPop">
              {this.state.superlikePlanStatus === 1 ? (
                <div className="premiumPopPlans pt-3 ">
                  <div className="text-center mb-3">
                    <div class="bold-font">
                      <Trans i18nKey="Out of Super Likes">
                        Out of Super Likes
                      </Trans>
                    </div>
                    <div class="premiumInfoSubText  secondaryText esmh-14">
                      <Trans i18nKey="premiumTextSuper">
                        Giving a Super like is a way to tell someone that you're
                        especially interested in them
                      </Trans>
                    </div>
                  </div>
                  <Swiper {...params2}>
                    {this.state.superlikeItems.map((item, index) => (
                      <div
                        className={
                          this.state.activeItem === item.id
                            ? "navigation--active"
                            : ""
                        }
                        onClick={this.handleSuperlikeItemClick.bind(
                          this,
                          item.id
                        )}
                        alt={item.id}
                        value={item.id}
                      >
                        <div className="premiumPrice">
                          <div className="apd10 daysPrice">
                            <div className="bold-font apk-30">
                              {item.superlike_count}
                            </div>
                            <div className=" bold-font apk-20 mt-n2">
                              {item.superlike_count === 1 ? (
                                <Trans i18nKey="Super like">Super like</Trans>
                              ) : (
                                <Trans i18nKey="Super likes">Super likes</Trans>
                              )}
                            </div>
                          </div>
                          <div className="apd5 apk-16 mini-price">
                            {this.state.currency}
                            {item.price}
                          </div>
                        </div>
                      </div>
                    ))}
                  </Swiper>
                  <ul class="ubp-ul text-center justify-content-end amt20">
                    <li class="in-flex">
                      <button
                        onClick={this.closeModal.bind(this, "modal6")}
                        class="btn-block amgAuto border-0 bg-white"
                      >
                        <Trans i18nKey="Cancel">Cancel</Trans>
                      </button>
                    </li>
                    <li class="in-flex">
                      <NavLink
                        to={{
                          pathname: "/app/WalletPayment",
                          paytype: { type: "superlike" },
                        }}
                      >
                        {" "}
                        <button class="btn-block amgAuto border-0 bg-white pink-color">
                          <Trans i18nKey="Continue">Continue</Trans>{" "}
                        </button>
                      </NavLink>
                    </li>
                  </ul>
                  {/* <div className="sidebarLastContent text-center">
                                    
                                                        <NavLink to={{
                                        pathname:'/app/PaymentOptions',
                                    paytype: {type:'superlike'} 
                                    }}>  <button className="btn-common btn-block"><Trans i18nKey="Continue">Continue</Trans></button></NavLink>
                                </div> */}
                </div>
              ) : (
                <div className="premiumPopPlans text-center">
                  {" "}
                  <Trans i18nKey="No Plans Available">
                    No Plans Available
                  </Trans>{" "}
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>

        {/* match Popup  */}

        <Modal
          isOpen={this.state.modal11}
          toggle={this.closeModal.bind(this, "modal11")}
          className="modal-dialog premiumPopup matchPopup vertically-center apd5 newGradiantPopup"
        >
          {this.state.gif == "yes" ? (
            <Confetti
              recycle={false}
              style={{ flex: 1, zIndex: 99999, position: "fixed" }}
            />
          ) : (
            ""
          )}
          <ModalBody>
            <div className="modal-content">
              <div className="match-body">
                <div className="justify-content-end text-center matchContent">
                  <Trans i18nKey="It's a Match">It's a Match</Trans>
                </div>
                <div className="justify-content-end text-center matchContentSub">
                  {/* You and {this.state.followername} like eatch other */}
                  <Trans i18nKey="Bel Baraka">Bel Baraka</Trans>
                </div>
                <div
                  className="modal-images media"
                  style={{
                    position: "relative",
                    justifyContent: "center",
                    margin: "15px 0 10px 0",
                  }}
                >
                  <div className="matchmedia">
                    <img src={this.state.userprofile} alt="" className />
                  </div>
                  <div
                    className="matchlike"
                    style={{ top: "unset !important", bottom: "5px" }}
                  />
                  <div className="matchmedia">
                    <img src={this.state.followerprofile} alt="" className />
                  </div>
                </div>
                <div className="justify-content-end text-center">
                  <button
                    className="bg-white pink-color matchButton"
                    onClick={this.Message}
                  >
                    <Trans i18nKey="Send message">Send message</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal12}
          toggle={this.closeModal.bind(this, "modal12")}
          className="modal-dialog premiumPopup matchPopup vertically-center apd5 newGradiantPopup"
        >
          <ModalBody>
            <div className="modal-content">
              <div className="match-body">
                <div
                  className="justify-content-end text-center matchContent"
                  id="matchid"
                >
                  <Trans i18nKey="Unlock to Match">Unlock to Match</Trans>
                </div>

                <div
                  className="modal-images media"
                  style={{
                    position: "relative",
                    justifyContent: "center",
                    margin: "15px 0 10px 0",
                  }}
                >
                  <div className="matchmedia">
                    <img src={this.state.userprofile} alt="" className />
                  </div>
                  <div
                    className="matchlike"
                    style={{ top: "unset !important", bottom: "5px" }}
                  />
                  <div className="matchmedia">
                    <img src={this.state.followerprofile} alt="" className />
                  </div>
                </div>
                <div className="justify-content-end text-center">
                  <button
                    className="bg-white pink-color matchButton"
                    onClick={this.showModal.bind(this, "modal15")}
                  >
                    <Trans i18nKey="Unlock">Unlock</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          backdrop="static"
          isOpen={this.state.modal13}
          toggle={this.closeModal.bind(this, "modal13")}
          className="modal-dialog premiumPopup matchPopup vertically-center apd5 newGradiantPopup"
        >
          <ModalBody>
            <div className="modal-content">
              <div className="match-body">
                <div
                  className="justify-content-end text-center matchContent"
                  id="matchids"
                >
                  <Trans i18nKey="Matches Pending">Matches Pending</Trans>
                </div>

                <div
                  className="modal-images media"
                  style={{
                    position: "relative",
                    justifyContent: "center",
                    margin: "15px 0 10px 0",
                  }}
                >
                  <div className="matchmedia">
                    <img src={this.state.userprofile} alt="" className />
                  </div>
                  <div
                    className="matchlike"
                    style={{ top: "unset !important", bottom: "5px" }}
                  />
                  <div className="matchmedia">
                    <img src={this.state.followerprofile} alt="" className />
                  </div>
                </div>
                <div className="justify-content-end text-center">
                  <button
                    className="bg-white pink-color matchButton"
                    onClick={this.closeModal.bind(this, "modal13")}
                  >
                    <Trans i18nKey="Ok">Ok</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal15}
          toggle={this.closeModal.bind(this, "modal15")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal15")}>
            <h4 class="modal-title">
              <Trans i18nKey="Join Premium">Join Premium</Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="premiumPop">
              <div className="premiumImgs">
                <Swiper {...params} shouldSwiperUpdate>
                  {this.state.permium_superlikeCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_superlike.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          <Trans i18nKey="Get">Get</Trans>{" "}
                          {this.state.permium_superlikeCount}{" "}
                          <Trans i18nKey="free super likes">
                            free super likes
                          </Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextSuper">
                            Giving a Super like is a way to tell someone that
                            you're especially interested in them
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.permium_boostCount > 0 ? (
                    <div>
                      <div className="premiumImgHolder">
                        <img
                          src={require("../../assets/img/sub_boost.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="premiumInfoHolder">
                        <div className="bold-font">
                          <Trans i18nKey="Get">Get</Trans>{" "}
                          {this.state.permium_boostCount}{" "}
                          <Trans i18nKey="free boost">free boost</Trans>
                        </div>
                        <div className="premiumInfoSubText  secondaryText esmh-14 ">
                          <Trans i18nKey="premiumTextBoost">
                            Be the top profile in your area for 30minutes to get
                            more matches, Keep Swipe right!
                          </Trans>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_location.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Change Location">Change Location</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextLocation">
                          Get match and chat with others around the world by
                          simply searching for a city
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Likes">Unlimited Likes</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimited">
                          Feel special again with 'Unlimited Likes'. Swipe right
                          as much as you want!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Rewind">Rewind</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextRewind">
                          Accidentally swiped on someone? Rewind lets you take
                          back your last Like or Nope
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_morelike2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Unlimited Liked">
                          Find out who likes you
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextUnlimiteds">
                          This feature allows you to see who has liked you!
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_profile.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Control your profile">
                          Control your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextProfile">
                          Limit what others see and make parts of your profile
                          information invisible to other people
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sub_visited.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Visitors">
                          See who visited your profile
                        </Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextVisited">
                          A Visitors feature lets you see who looked at your
                          profile or ‘visited’ your profile
                        </Trans>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="premiumImgHolder">
                      <img
                        src={require("../../assets/img/sud_add2.png")}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="premiumInfoHolder">
                      <div className="bold-font">
                        <Trans i18nKey="Turn Off Ads">Turn Off Ads</Trans>
                      </div>
                      <div className="premiumInfoSubText  secondaryText esmh-14 ">
                        <Trans i18nKey="premiumTextAds">
                          Have fun swiping with uninterrupted ads
                        </Trans>
                      </div>
                    </div>
                  </div>
                </Swiper>
              </div>

              {this.state.timer_status == 1 ? (
                <Countdown
                  startdate={this.state.start_date}
                  enddate={this.state.end_date}
                ></Countdown>
              ) : (
                ""
              )}

              <div className="premiumPopPlans">
                <Swiper {...params2}>
                  {this.state.itemss.map((item, index) => (
                    <div
                      className={
                        this.state.activeItems === item.id
                          ? "navigation--active"
                          : ""
                      }
                      onClick={this.handleItemClick.bind(this, item.id)}
                      alt={item.id}
                      value={item.id}
                    >
                      <div className="premiumPrice">
                        <div className="apd10 daysPrice">
                          <div className="bold-font apk-30">{item.days}</div>
                          <div className=" bold-font apk-24 mt-n2">
                            <Trans i18nKey={item.type}>{item.type}</Trans>
                          </div>
                        </div>
                        <div className="apd5 apk-16 mini-price">
                          {this.state.currency}
                          {item.price}
                        </div>
                      </div>
                    </div>
                  ))}
                </Swiper>
              </div>

              {/* <div className="sidebarLastContent text-center">
                            <NavLink to={{
                                pathname:'/app/WalletPayment',
                                paytype: {type:'premium'} 
                            }}>  <button className="btn-common btn-block"><Trans i18nKey="Continue">Continue</Trans></button></NavLink>
                            </div> */}

              <ul class="ubp-ul text-center justify-content-end amt20">
                <li class="in-flex">
                  <button
                    class="btn-block amgAuto border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal15")}
                  >
                    <Trans i18nKey="Cancel">Cancel</Trans>
                  </button>
                </li>
                <li class="in-flex">
                  <NavLink
                    to={{
                      pathname: "/app/WalletPayment",
                      paytype: { type: "premium" },
                    }}
                  >
                    {" "}
                    <button class="btn-block amgAuto border-0 bg-white pink-color">
                      <Trans i18nKey="Continue">Continue</Trans>{" "}
                    </button>
                  </NavLink>
                </li>
              </ul>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default withTranslation("translations")(LikeRequestNew);
